import React from 'react';
import {useIntl} from 'react-intl';
import {FilterDatePicker} from '../../../_common/components/FieldDatepicker';
import ClearIcon from '../../../_common/components/ClearIcon';
import {useInspectionsMapFiltersContext} from '../../context';
import {FilterOptionSelect} from '../../../_common/components/FilterSelect';
import {useCitiesContext, useStreetsContext} from '../../../_common/components/CitiesAndStreets';
import styles from '../../../_common/styles/filtersBar.module.scss';

export const InspectionMapFilters = () => {
  const intl = useIntl();
  const {
    fromDate,
    toDate,
    cityID,
    streetID,
    updateFromDate,
    updateToDate,
    updateCityID,
    updateStreetID
  } = useInspectionsMapFiltersContext();
  const {cities} = useCitiesContext();
  const {streets, updateStreets} = useStreetsContext();

  return (
    <div className={styles.container}>
      <div className={styles.filtersContainer}>
        <div className={styles.filter}>
          <FilterDatePicker
            className="px-4"
            placeholder={intl.formatMessage({id: `filter-placeholder-fromDate`, defaultMessage: 'From date'})}
            value={fromDate}
            onChange={date => updateFromDate(date)}
            maxDate={toDate || ''}
            label={fromDate
              ? intl.formatMessage({id: `filter-placeholder-fromDate`, defaultMessage: 'From date'})
              : null
            }
          />
          <ClearIcon
            onClick={() => updateFromDate(null)}
          />
        </div>
        <div className={styles.filter}>
          <FilterDatePicker
            className="px-4"
            placeholder={intl.formatMessage({id: `filter-placeholder-toDate`, defaultMessage: 'To date'})}
            value={toDate}
            onChange={date => updateToDate(date)}
            minDate={fromDate || ''}
            label={toDate
              ? intl.formatMessage({id: `filter-placeholder-toDate`, defaultMessage: 'To date'})
              : null
            }
          />
          <ClearIcon
            onClick={() => updateToDate(null)}
          />
        </div>
        <FilterOptionSelect
          fieldName={'cityID'}
          valueName={cityID}
          options={cities}
          placeholder={intl.formatMessage({id: `filter-placeholder-city`, defaultMessage: 'City'})}
          containerClassnames={styles.filter}
          onChange={async (option) => {
            if (option) {
              await updateCityID(parseInt(option.value, 10));
              await updateStreets(option.value);
            } else {
              await updateCityID(null);
            }
          }}
          onClear={() => updateCityID(null)}
        />
        <FilterOptionSelect
          fieldName={'streetID'}
          valueName={streetID}
          options={streets}
          placeholder={intl.formatMessage({id: `filter-placeholder-street`, defaultMessage: 'Street'})}
          containerClassnames={styles.filter}
          disabled={!cityID || cityID === -1}
          onChange={option => updateStreetID(option ? parseInt(option.value, 10) : null)}
          onClear={() => updateStreetID(null)}
        />
      </div>
    </div>
  );
};